module.exports = __webpack_public_path__ + "img/杭州丽脂.29b4599.png";